export const attentionModalFunc = (event: Event): void => {
    event.preventDefault();
    // IEのみ
    // event.returnValue = 'カスタマイズした矢の情報が消えてしまいますが宜しいでしょうか';
};
